import Cookies from "js-cookie";
import config from "../config";

const tokenKey = config.auth.tokenKey;

export function getToken() {
  if (window.dd) {
    return window.sessionStorage.getItem(tokenKey);
  }
  return Cookies.get(tokenKey);
}

export function setToken(token) {
  if (window.dd) {
    return window.sessionStorage.setItem(tokenKey, token);
  }
  return Cookies.set(tokenKey, token);
}

export function removeToken() {
  if (window.dd) {
    return window.sessionStorage.removeItem(tokenKey);
  }
  return Cookies.remove(tokenKey);
}
